export default "__VITE_ASSET__CLxymipM__"